import { type AnyGraphNode, nodeName } from '../types/graphNodes';

/**
 * Content authors sometimes name throwaway/placeholder entries "zzz…" so they
 * sort to the end. These must never surface anywhere in jnana-web.
 */
export function isPlaceholderNode(node: AnyGraphNode): boolean {
  // Check the ASCII normalized name ('en') so detection is language-independent.
  const name = nodeName(node, 'en')?.trim().toLowerCase();
  return !!name && name.startsWith('zzz');
}

/** Drop placeholder/test nodes (e.g. names starting with "zzz") from display. */
export function visibleNodes<T extends AnyGraphNode>(nodes: T[]): T[] {
  return nodes.filter((n) => !isPlaceholderNode(n));
}
